export default __webpack_public_path__ + "static/media/github.7a87f172.svg";